import ProfileContainer from "../../container/admin/profile";

const Profile = () => {
    return <ProfileContainer />;
};

export default Profile;